module.exports = __webpack_public_path__ + "img/creating-value.c02b3924.webp";